<template>

<div class="relative cursor-pointer">
    <button @click="openDrawer">
        <i class="fas fa-bell text-xl" :class="{ bounce: hasNewNotification }"></i>
        <span
            v-if="unreadCount"
            class="badge"
        >
            ({{ displayCount }})
        </span>
    </button>

</div>

</template>

<script>
import {computed, ref} from 'vue';
import {useStore} from "vuex";

export default{

setup(){

    const store=useStore();

    const hasNewNotification=computed(
        ()=>store.getters["notifications/hasNewNotification"]
    );

    const unreadCount=computed(
        ()=>store.getters["notifications/unreadCount"]
    );

    const displayCount = computed(() =>
        unreadCount.value > 99 ? "99+" : unreadCount.value
    );

    const openDrawer = () => {
        store.commit("notifications/TOGGLE_DRAWER")
    }

    return{

        unreadCount,displayCount,hasNewNotification,
        openDrawer

    }

}

}
</script>

<style scoped>

.badge{

    position:absolute;

    top:-8px;
    right:-8px;

    min-width:20px;
    height:20px;

    border-radius:50%;

    background:#ef4444;

    color:white;

    display:flex;

    align-items:center;

    justify-content:center;

    font-size:11px;

    font-weight:bold;

}
@keyframes bell {

    0% {transform:rotate(0);}
    20% {transform:rotate(20deg);}
    40% {transform:rotate(-20deg);}
    60% {transform:rotate(10deg);}
    80% {transform:rotate(-10deg);}
    100% {transform:rotate(0);}

}

.bounce{
    animation:bell .7s;

}

</style>